'use client';

import useCommonLinks from '@/lib/getters/useCommonLinks';
import { useTranslations } from 'next-intl';
import Box from '../ui/Box';
import Btn from '../ui/Btn';
import Container from '../ui/Container';
import Flex from '../ui/Flex';
import Txt from '../ui/Txt';

const SearchBanner = () => {
  const t = useTranslations('search');
  const { search } = useCommonLinks();

  return (
    <Box colorSet="cream" paper cx={{ pY: '4xl' }}>
      <Container>
        <Flex alignItems="center">
          <Txt variant="h4" cx={{ textAlign: 'center' }}>
            {t('eventSearchCallToAction')}
          </Txt>
          <Txt variant="body" cx={{ textAlign: 'center', mB: 'lg' }}>
            {t('eventSearch')}
          </Txt>
          {search.uri && (
            <Btn href={search.uri} size="large" color="black">
              {t('eventSearchAction')}
            </Btn>
          )}
        </Flex>
      </Container>
    </Box>
  );
};

export default SearchBanner;
